'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './history.routes';

export class HistoryComponent {

  constructor($stateParams, HistoryService, Auth, User) {
    'ngInject';

    this.isAdmin = Auth.isAdminSync;
    this.user = Auth.getCurrentUserSync();
    this.entityId = $stateParams.id;
    this.UserService = User;
    
    var mapHistoryTypes = {
      bulletin: "Bulletin Board Post",
      news: "News Post",
      gallery: 'Gallery',
      user: 'User'
    };

    var entityHtml = {
      bulletin: '<bulletin-post data="event.dataAfter" detail="true" history="true" admin="false" user="ctrl.user" delete="ctrl.delete()"></bulletin-post>',
      news: '<news-post data="event.dataAfter" feature="true"></news-post>',
      gallery: '',
      user: ''
    };

    var mapEventIcon = {
      created: 'glyphicon-asterisk',
      edited: 'glyphicon-pencil',
      deleted: 'glyphicon-trash',
      error: 'glyphicon-warning-sign',
      accepted: 'glyphicon-ok',
      rejected: 'glyphicon-remove',
      signedUp: 'glyphicon-asterisk',
      loggedIn: 'glyphicon-thumbs-up',
      passwordReset: 'glyphicon-refresh',
      feedback: 'glyphicon-envelope'
    };

    var mapEventClass = {
      created: 'success',
      deleted: 'danger',
      error: 'danger',
      signedUp: 'success',
      accepted: 'success',
      rejected: 'warning'
    };

    var userMap = {}; // Map (ID -> User) for caching purposes

    var getContent = function(history) {
      if (history.actionType === 'created'
        || history.actionType === 'edited') {
        return entityHtml[history.entityType]
      } else {
        return history.actionMeta;
      }
    };

    this.events = [];

    HistoryService.getByEntity({id: $stateParams.id}, data => {

      var events = [];

      data.forEach(history => {

        this.entityType = mapHistoryTypes[history.entityType];
        
        var badgeClass = mapEventClass[history.actionType] || "info";
        var badgeIconClass = mapEventIcon[history.actionType];

        events.push({
          badgeClass,
          badgeIconClass,
          title: history.action,
          dataAfter: history.dataAfter,
          content: getContent(history),
          creationDate: history.meta.creationDate,
          creationUser: history.meta.creationUser,
          isCollapsed: true
        });

      });

      // newest history on top
      this.events = events.reverse();

      this.events.forEach(event => {
        if (event.dataAfter && event.dataAfter.meta && event.dataAfter.meta.creationUser) {

          if (userMap[event.dataAfter.meta.creationUser]) {
            event.dataAfter.meta.creationUser = user;
          } else {
            this.UserService.getOne({id: event.dataAfter.meta.creationUser}, user => {
              userMap[event.dataAfter.meta.creationUser] = user;  // cache the object
              event.dataAfter.meta.creationUser = user;
            });
          }
        }
      });
      
      if (this.events.length === 0)
        this.entityType = "No historical data available for this entity";
    });

  }

  toggleAll() {
    this.events.forEach(event => {
      event.isCollapsed = !event.isCollapsed;
    })
  }

  getUserShort(user) {
    try {
      return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
    } catch(e) {
      return "unknown";
    }
  }

}

export default angular.module('conduu.ap.history.view', [uiRouter])
  .config(routes)
  .component('history', {
    template: require('./history.html'),
    controller: HistoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/history/view/history.component.js